{
  "title": "Crear cuenta",
  "subtitle": "Regístrate para comenzar",
  "emailLabel": "Correo",
  "passwordLabel": "Contraseña",
  "confirmPasswordLabel": "Confirmar contraseña",
  "signUpButton": "Registro",
  "requirementsText": "Debe tener 8+ caracteres con mayúsculas, minúsculas y números",
  "strengthLabel": "Intensidad: {{strength}}",
  "passwordStrength": {
    "tooShort": "Muy corto",
    "weak": "Débil",
    "fair": "Bien",
    "good": "Bueno",
    "strong": "Fuerte"
  },
  "alreadyHaveAccount": "¿Ya tienes una cuenta?",
  "logIn": "Ingresar",
  "errors": {
    "invalidEmail": "Por favor, ingresa un correo electrónico válido",
    "tooShort": "La contraseña debe tener al menos 8 caracteres",
    "needsUppercase": "La contraseña debe contener al menos una letra mayúscula",
    "needsLowercase": "La contraseña debe contener al menos una letra minúscula",
    "needsNumber": "La contraseña debe contener al menos un número",
    "noMatch": "Las contraseñas no coinciden",
    "createFailed": "Error al crear la cuenta",
    "createFailedRetry": "No se pudo crear la cuenta. Intenta de nuevo.",
    "genericError": "Ocurrió un error. Intenta de nuevo."
  }
}
